export enum ActionOption {
  ACCEPT,
  REJECT,
  REOPEN,
  SEND_REQUEST_TO_REOPEN,
}
